/* 🤖 this file was generated by svg-to-ts*/
export const icoGitBranch: {
  name: 'git-branch';
  data: string;
} = {
  name: 'git-branch',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 4c-1.66 0-3 1.34-3 3 0 1.3.84 2.4 2 2.82V11c0 1.1-.9 2-2 2H9c-.73 0-1.41.21-2 .55V7.82C8.16 7.4 9 6.3 9 5c0-1.66-1.34-3-3-3S3 3.34 3 5c0 1.3.84 2.4 2 2.82v8.37C3.84 16.6 3 17.7 3 19c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.25-.77-2.3-1.85-2.75C7.45 15.52 8.16 15 9 15h6c2.21 0 4-1.79 4-4V9.82C20.16 9.4 21 8.3 21 7c0-1.66-1.34-3-3-3zM6 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM18 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" fill="#909090"/></svg>`
};
